import React from 'react';
import { SvgIcon } from '@mui/material';
const SvgStar = (props) => (
  <SvgIcon {...props} title="Star">
    <svg
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="m10 2 2.351 4.764 5.257.764-3.804 3.708.898 5.236L10 14l-4.702 2.472.898-5.236-3.804-3.708 5.257-.764L10 2Z"
        fill="#00E1C6"
      />
    </svg>
  </SvgIcon>
);
export default SvgStar;
